import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

const FilterIconSelector = ({
  filter,
  isActive,
  selectFilter,
  mdSize = 105,
  xlSize = 140,
  xsSize = 68,
}) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="gift-icon-center">
        <button
          className="gift-icon__button"
          onClick={() => selectFilter(filter)}
          type="button"
        >
          <div
            className={classNames('gift-icon__circle', {
              'gift-icon__circle--active': isActive,
            })}
          />
          <h2
            className={classNames('gift-icon__text', {
              'gift-icon__text--active': isActive,
            })}
          >
            {filter.linkText}
          </h2>
        </button>
      </div>
      <style jsx>{`
        .gift-icon-center {
          text-align: center;
        }
        .gift-icon__button {
          background: none;
          border: none;
        }
        .gift-icon__circle {
          background-image: url('${filter.imageUrl}');
          background-repeat: no-repeat;
          background-position: center;
          background-size: ${xsSize}px ${xsSize}px;
          border-color: ${theme.colors.navbackground};
          border-style: solid;
          border-width: 4.5px;
          border-radius: 100%;
          margin: 0 auto;
          height: ${xsSize + 6}px;
          width: ${xsSize + 6}px;
        }
        .gift-icon__circle--active {
          border-color: ${theme.colors.primary};
        }
        .gift-icon__text {
          color: ${theme.colors.primary};
          font-size: 11px;
          font-weight: normal;
          padding: 0;
          margin: 5px auto;
          text-align: center;
        }
        .gift-icon__text--active {
          font-weight: bold;
          text-decoration: underline;
        }
        @media only screen and (min-width: ${theme.breakpoints.mdUp}) {
          .gift-icon__circle {
            border-width: 6px;
            background-size: ${mdSize}px ${mdSize}px;
            height: ${mdSize + 6}px;
            width: ${mdSize + 6}px;
          }
          .gift-icon__text {
            font-size: 12px;
            padding: 0 20px;
          }
        }
        @media only screen and (min-width: ${theme.breakpoints.xlUp}) {
          .gift-icon__circle {
            border-width: 7px;
            background-size: ${xlSize}px ${xlSize}px;
            width: ${xlSize + 6}px;
            height: ${xlSize + 6}px;
          }
          .gift-icon__text {
            font-size: 16px;
            padding: 0 20px;
          }
        }
      `}</style>
    </>
  );
};

export default FilterIconSelector;

FilterIconSelector.propTypes = {
  filter: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  mdSize: PropTypes.number,
  selectFilter: PropTypes.func.isRequired,
  xlSize: PropTypes.number,
  xsSize: PropTypes.number,
};
